import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';

/** @component
 * Low level component used by the Desktop layout.
 *
 * Produces "sections" of the page, separated with a large spacing to
 * visually separate its child components.
 *
 * @param children {Array<Object> | Object}
 * @returns {Element}
 * @constructor
 */
const SectionedLayout = ({ children }) => {
    const childrenArr = React.Children.toArray(children);
    return (
        <Grid
            container
            spacing={1}
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignContent={'center'}
        >
            {childrenArr.map((child, i) => (
                <Grid key={i} item xs={12}>
                    {child}
                </Grid>
            ))}
        </Grid>
    );
};

SectionedLayout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

export default SectionedLayout;
